import request from '@/config';
import { useAppStoreWithOut } from '@/store/app';

enum Apis {
	CreateContract = `/api/Contract/InsertContract`,
	ExpCtAuditWord = `/api/contract/exportauditword`,
	TurnBackNodes = `/api/contract/getturnbacknodelist`,
	Transfer = `/api/contractaudits/contracttransfer`,
	ContractUrge = `/api/contractaudits/audittourge`, // 催办
	ContractDraftList = `/api/contract/getdraftcontractpaged`, // 草稿列表
	DeleteContract = `/api/Contract/DeleteContract`, // 删除草稿或者退回状态的数据
	GetEditData = `/api/contractdraft/getcongractdetail`, // 获取草稿编辑信息
	SetViewRecord = `/api/contractdraft/saveViewRecord`, //保存浏览记录
	GetContractNum = `/api/contractno/getcontractnumber`, // 获取合同编号
	ContractNotDraft = `/api/contract/getcontractexceptdraftpaged`,		// 获取非草稿/退回合同数据
}

export const SetViewRecord = (searchIpt?: any): Promise<IResponse> => request.post({ url: Apis.SetViewRecord, data: searchIpt });
/* 获取非草稿/退回合同数据 */
export const GetContractNotDraftApi = (searchIpt?: any): Promise<IResponse> => request.post({ url: Apis.ContractNotDraft, data: searchIpt });

/* 合同草稿列表 */
export const GetContractDraftList = (search?: any): Promise<IResponse> => request.post({ url: Apis.ContractDraftList, data: search });

/* 删除草稿或者退回状态的合同 */
export const DeleteDraftListApi = (search?: any): Promise<IResponse> => request.post({ url: Apis.DeleteContract, data: search });

/* 获取草稿详细信息 */
export const GetDraftEditDataApi = (rowId: string): Promise<IResponse> => request.post({ url: Apis.GetEditData, data: { id: rowId } });

/* 合同催办 */
export const AuditUrgeApi = (workId: string): Promise<IResponse> => request.post({ url: Apis.ContractUrge, data: { id: workId } });

export const ContractTransferApi = (transferDto: any): Promise<IResponse> =>
	request.post({
		url: Apis.Transfer,
		data: transferDto,
	});

export const GetTurnBackNodesApi = (contractId: string): Promise<IResponse> =>
	request.post({
		url: Apis.TurnBackNodes,
		data: { id: contractId },
	});

/* 导出合同/文件会签审批表 */
export const ExportCtAuditWordApi = (contractId: string): Promise<IResponse> =>
	request.post({
		url: Apis.ExpCtAuditWord,
		data: { id: contractId },
		responseType: 'blob',
	});

export const ContractInsertApi = (formData: any): Promise<IResponse> =>
	request.post({
		url: Apis.CreateContract,
		data: formData,
	});

/* Dtos */
import { ContractSearch, ContractCreate, CtAuditDto, ContractDelDto } from './contract.type';
import { CreateByTemplateDto, StampSubmitDto, PutInSubmitDto } from './contract.dto';

const appStore = useAppStoreWithOut();

/* 合同：查询(LIST) */
export const GetContractListApi = (searchIpt: ContractSearch): Promise<IResponse> => {
	return request.post({ url: '/api/Contract/GetContractPage', data: searchIpt });
};

/* 合同：详细(Detail) */
export const GetContractApi = (rowId: string): Promise<IResponse> => {
	const login = appStore.getLoginInfo as LoginInfo;
	const searchIpt = { tenant_id: 1, id: rowId, curr_user_id: login.user_id };
	return request.post({ url: '/api/Contract/GetContractInfo', data: searchIpt });
};

/* 合同：创建(CREATE) */
export const CreateContractApi = (createIpt: ContractCreate): Promise<IResponse> => {
	const login = appStore.getLoginInfo as LoginInfo;

	const loginInfo: CAccountInfo = {
		curr_user_id: login.user_id,
		tenant_id: '1',
		company_id: login.company_id,
		created_user_id: login.user_id,
	};

	createIpt = Object.assign({}, createIpt, loginInfo);

	return request.post({ url: '/api/Contract/InsertContract', data: createIpt });
};

/* 合同：修改(Editor) */
export const EditContractApi = (editIpt: ContractCreate): Promise<IResponse> => {
	const login = appStore.getLoginInfo as LoginInfo;

	const editInfo: UAccountInfo = {
		curr_user_id: login.user_id,
		tenant_id: '1',
		company_id: login.user_id,
		revision: editIpt.revision,
		updated_user_id: login.user_id,
	};

	editIpt = Object.assign({}, editIpt, editInfo);

	return request.post({ url: '/api/Contract/UpdateContract', data: editIpt });
};

/* 合同：删除(Delete) */
export const delContract = (delData: ContractDelDto): Promise<IResponse> => {
	const login = appStore.getLoginInfo as LoginInfo;

	const delParams = Object.assign({}, delData, { deleted_user_id: login.user_id, tenant_id: '1' });

	return request.post({ url: '/api/Contract/DeleteContract', data: delParams });
};

/* 合同：获取附件(Files) */
export const GetCtFilesApi = (contractId: string): Promise<IResponse> => {
	const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: contractId };
	return request.post({ url: '/api/Contract/files', data: delParams });
};

/* 合同：删除附件(Files) */
export const DelCtFilesApi = (contractId: string): Promise<IResponse> => {
	const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: contractId };
	return request.post({ url: '/api/Contract/delfiles', data: delParams });
};

/* 合同：提交(Submit) */
export const CtSubmitApi = (contractId: string, remark: string, revision: string): Promise<IResponse> => {
	const login = appStore.getLoginInfo as LoginInfo;

	const auditDto: CtAuditDto = {
		id: contractId,
		revision: revision,
		remark: remark,
	};

	return request.post({ url: '/api/contract/submitcontract', data: auditDto });
};

/* 合同：通过审核(Agree) */
export const CtAgreeApi = (auditDto: CtAuditDto): Promise<IResponse> => {
	return request.post({ url: '/api/contract/agreecontract', data: auditDto });
};

/* 合同：退回审核(Reject) */
export const CtRejectApi = (auditDto: CtAuditDto): Promise<IResponse> => {
	return request.post({ url: '/api/contract/rejectcontract', data: auditDto });
};

export const GetWorkListApi = (workId: string | number): Promise<IResponse> => {
	const login = appStore.getLoginInfo as LoginInfo;
	return request.post({ url: `/api/workflow/gettrack?work_id=${workId}&user_id=${login.user_id}&company_id=${login.company_id}`, data: {} });
};

/* 获取合同详细(WorkId) */
export const GetByWorkIdApi = (workId: string): Promise<IResponse> => {
	return request.post({ url: '/api/contract/getcontractbyworkid', data: { work_id: workId } });
};

/* 合同：履约情况查询(LIST) */
export const GetPerformListApi = (searchIpt: ContractSearch): Promise<IResponse> => {
	return request.post({ url: '/api/contract/getperforncontractpage', data: searchIpt });
};

/* 获取合同编号 */
export const GetCtNumberApi = (): Promise<IResponse> => request.post({ url: Apis.GetContractNum, data: {} });

/* 获取合同编号 */
export const InsCtByTempApi = (datas: CreateByTemplateDto): Promise<IResponse> => {
	return request.post({ url: '/api/contract/createbytemplate', data: datas });
};

/* 获取关联合同 */
export const RelContractListApi = (contractid: string): Promise<IResponse> => {
	return request.post({ url: 'api/contract/getrelcontracts', data: { id: contractid } });
};


/* 合同：终止合同(Canence) */
export const CtCanenceApi = (datas: ContractDelDto): Promise<IResponse> => {
	return request.post({ url: '/api/contract/canencecontract', data: datas });
};

/* 合同：作废合同(Cancel) */
export const CtCancelApi = (datas: ContractDelDto): Promise<IResponse> => {
	return request.post({ url: '/api/contract/cancelcontract', data: datas });
};
